import { render, staticRenderFns } from "./ticketDetailInfo.vue?vue&type=template&id=c31b5b7a&scoped=true&"
import script from "./ticketDetailInfo.vue?vue&type=script&lang=js&"
export * from "./ticketDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./ticketDetailInfo.vue?vue&type=style&index=0&id=c31b5b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31b5b7a",
  null
  
)

export default component.exports